//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TaggedObject.js";
let d=[[],[[[],"GetInfo",{R_:{info:''}},0,0],[[],"GetObjectName",{R_:{name:''}},0,0],[["other"],"CompareWith",{R_:{res:''}},1,0]],[]];
SPLM.OMAttribute = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.OMAttribute";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.OMAttribute.Info = class{
    constructor(name,defining_class,defining_schema,type){
        this.name=name;this.defining_class=defining_class;this.defining_schema=defining_schema;this.type=type;}
    get Name(){return this.name}
    set Name(val){this.name = val}
    get DefiningClass(){return this.defining_class}
    set DefiningClass(val){this.defining_class = val}
    get DefiningSchema(){return this.defining_schema}
    set DefiningSchema(val){this.defining_schema = val}
    get Type(){return this.type}
    set Type(val){this.type = val}
};

SPLM.OMAttribute.Type = Object.freeze({
    "Int" : "Int", "Tag" : "Tag"});

export default SPLM;